module.exports = __webpack_public_path__ + "reportlabSlideoutAsset2.a00a4e30b3f44cb9b10008fc07e15538.png";